'use client';

import { Button, Empty, message, Pagination, Select, Spin } from 'antd';
import { GalleryComp, PrimaryServiceCardComp, ReviewCardComp, ServiceFilterComp } from 'components';
import { GlobalContext } from 'context';
import { API, PATH } from 'data';
import { useContext, useEffect, useState } from 'react';
import { BiSortAlt2 } from 'react-icons/bi';
import { FaFilter } from 'react-icons/fa';
import { nextBrowser, RestAPI } from 'scripts';
import { PaginationType, ReviewType, ServiceType } from 'types';
import ServiceBrandInfo from './brandInfo/brandInfo.index';
import styles from './serviceDetail.module.scss';
import { __ServiceDetailPropsType } from './serviceDetail.type';
import ServiceInfoComp from './serviceInfo/serviceInfo.index';
function ServiceDetailComp({
  data,
  categories,
  siblings,
  initialFilter
}: __ServiceDetailPropsType) {
  const [isOpen, setIsOpen] = useState(false);
  const [filterValues, setFilterValues] = useState(typeof initialFilter.brand !== 'string' ? initialFilter : {
    ...initialFilter,
    brand: [initialFilter.brand]
  });
  const [siblingsList, setSiblingsList] = useState<PaginationType<ServiceType> | undefined>(siblings);
  const [reviewsList, setReviewsList] = useState<{
    data: PaginationType<ReviewType>;
    page: number;
  }>();
  const [messageApi, contextHolder] = message.useMessage();
  const langText = useContext(GlobalContext).langText;
  const lang = langText.serviceDetail;
  const sortList: {
    id: number;
    title: string;
    slug: string;
  }[] = [{
    id: 5,
    title: lang.mostPriority,
    slug: 'most_priority'
  }, {
    id: 1,
    title: lang.newest,
    slug: 'newest'
  }, {
    id: 2,
    title: lang.oldest,
    slug: 'oldest'
  }, {
    id: 3,
    title: lang.most_visited,
    slug: 'most_order'
  }, {
    id: 4,
    title: lang.most_popular,
    slug: 'most_favorite'
  }];
  const sortHandler = (slug: string) => {
    setFilterValues({
      ...filterValues,
      order: slug
    });
  };
  const buyHandler = (service: ServiceType) => {
    setSiblingsList(list => {
      if (list) {
        const newList = {
          ...list
        };
        const index = list.data.findIndex(i => i.id === service.id);
        if (index > -1) {
          newList.data[index].is_ordered = 1;
        }
        return newList;
      }
    });
  };
  const getComments = (page: number) => {
    setReviewsList(undefined);
    RestAPI.get<PaginationType<ReviewType>>(API.order.public, {
      lang: langText.lang,
      page_size: 4,
      page,
      service__slug: decodeURIComponent(data.slug),
      ordering: '-created_at'
    }).then(res => setReviewsList({
      data: res.data,
      page
    })).catch(() => {
      messageApi.open({
        type: 'error',
        content: lang.errorMessage
      });
    });
  };
  useEffect(() => {
    const params: {
      [key: string]: string | string[];
    } = {};
    // if (filterValues.serviceType) params.serviceType = filterValues.serviceType;
    if (filterValues.category) params.category = filterValues.category;
    if (filterValues.starGTE) params.starGTE = filterValues.starGTE.toString();
    if (filterValues.starLTR) params.starLTR = filterValues.starLTR.toString();
    if (filterValues.order) params.order = filterValues.order;
    if (filterValues.search) params.search = filterValues.search;
    if (filterValues.page) params.page = filterValues.page;
    const path = new URL(nextBrowser?.window?.location.origin + PATH(langText.lang).services.detail(data, params));
    filterValues.brand?.map(brand => path.searchParams.append('brand', brand));
    window.history.replaceState(null, '', path);
    if (filterValues.category === initialFilter.category && filterValues.order === initialFilter.order && filterValues.search === initialFilter.search && filterValues.starGTE === initialFilter.starGTE && filterValues.starLTR === initialFilter.starLTR && filterValues.page === initialFilter.page) {
      setSiblingsList(siblings);
    } else {
      const newParams: {
        [key: string]: string | string[];
      } = {};
      if (params.category) newParams.category_and_descendants = params.category;
      if (params.starGTE) newParams.star_gte = params.starGTE.toString();
      if (params.starLTR) newParams.star_lte = params.starLTR.toString();
      if (params.order) newParams.order = params.order;
      if (params.search) newParams.title__icontains = params.search;
      if (params.page) newParams.page = params.page;
      // if (params.serviceType) newParams.serviceType = params.serviceType;

      setSiblingsList(undefined);
      RestAPI.get<PaginationType<ServiceType>>(API.services.siblings(data.key), {
        ...newParams,
        lang: langText.lang,
        page_size: 5
      }).then(res => setSiblingsList(res.data)).catch(({
        status
      }) => {
        if (status === 404) setSiblingsList({
          num_of_pages: 0,
          data: [],
          count: 0
        });else messageApi.open({
          type: 'error',
          content: lang.errorMessage
        });
      });
    }
  }, [filterValues]);
  useEffect(() => getComments(1), []);
  return <div className={`${styles['service-detail-layout']} main-content mt-10`} data-sentry-component="ServiceDetailComp" data-sentry-source-file="serviceDetail.index.tsx">
            {contextHolder}
            <div className={`${styles['info-slider']} d-flex`}>
                <ServiceInfoComp data={data} data-sentry-element="ServiceInfoComp" data-sentry-source-file="serviceDetail.index.tsx" />
                {data.gallery && data.gallery.length !== 0 && <div className={`${styles['slider']} flex-1`}>
                        <GalleryComp data={data.gallery} className={`${styles['slider-service']} h-100`} title={data.title} />
                    </div>}
            </div>
            <div className={`${styles['conditions-description']}`}>
                <div className="mb-2">
                    <h2 className="t-h4 t-700 t-dark1 mb-2">{lang.descriptions}</h2>
                    <div dangerouslySetInnerHTML={{
          __html: data.description
        }}></div>
                </div>
                <div className="mb-2">
                    <h2 className="t-h4 t-700 t-dark1 mb-2">{lang.terms_of_use}</h2>
                    <p dangerouslySetInnerHTML={{
          __html: data.use_terms
        }}></p>
                </div>
                <ServiceBrandInfo brand={data.brand} data-sentry-element="ServiceBrandInfo" data-sentry-source-file="serviceDetail.index.tsx" />
            </div>
            {Object.keys(filterValues).filter(i => i !== 'order').length === 0 && siblingsList?.count === 0 ? null : <div className={`${styles['filter-card']} d-flex`}>
                    <div className={`${styles['filter']} d-pre-lg-none`}>
                        <ServiceFilterComp isOpen={isOpen} setIsOpen={setIsOpen} category={categories} filterValues={filterValues} setFilterValues={setFilterValues} />
                    </div>
                    <div className={`${styles['card-list']}`}>
                        <h3 className="t-800 t-h3 t-dark mb-3 d-pre-md-none">{lang.other_services}</h3>
                        <h3 className="t-800 t-h3 t-dark mb-3 d-none d-pre-md-block">{lang.other_services}</h3>
                        <div className={`${styles['btn-box']} d-none d-pre-lg-flex justify-content-between align-items-center gap-16 mb-2`}>
                            <Button onClick={() => setIsOpen(true)} type="primary" className="d-none-i d-pre-lg-flex-i gap-8 w-100 center-content-x">
                                <FaFilter size={15} /> {lang.filters}
                            </Button>
                            <Select placeholder={lang.ordering} className="d-none-i d-pre-lg-flex-i w-100 text-center" suffixIcon={<BiSortAlt2 size={20} />} options={sortList} onChange={sortHandler} value={filterValues?.order ?? null} />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2 d-pre-lg-none">
                            <span className="d-flex align-items-center">
                                <span className="t-500 t-p1 t-dark1 d-block">{lang.ordering} :</span>
                                {sortList.map(item => <span onClick={() => sortHandler(item.slug)} key={item.id} className={`${item.slug === filterValues?.order ? styles['active'] : ''} t-p1 t-400 t-dark3`}>
                                        {item.title}
                                    </span>)}
                            </span>
                            <span className="d-block t-p1 t-400 t-dark3">
                                {siblingsList?.count} {lang.result}
                            </span>
                        </div>
                        <div>
                            {siblingsList?.data.length === 0 ? <Empty className="mt-8" description={lang.empty} /> : siblingsList ? siblingsList.data.map(service => <PrimaryServiceCardComp key={service.id} data={service} onBuy={() => buyHandler(service)} params={filterValues} />) : <div className="w-100 pv-6 center-content">
                                    <Spin />
                                </div>}
                        </div>
                        <div className={`${styles['pagination-layout']} ${(siblingsList?.count ?? 0) > 5 ? 'd-flex' : 'd-none'} center-content mt-6`}>
                            <div className={`${styles['pagination']} d-flex center-content mt-6`}>
                                <Pagination size="small" current={filterValues.page ? Number(filterValues.page) : 1} pageSize={5} total={siblingsList?.count} showSizeChanger={false} hideOnSinglePage onChange={e => setFilterValues({
              ...filterValues,
              page: e.toString()
            })} />
                            </div>
                        </div>
                    </div>
                </div>}
            <div className={`${styles['review-list']} mb-10 ${reviewsList?.data.count === 0 ? 'd-none-i' : ''}`}>
                <span className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="t-h3 t-800 t-dark1">{lang.customers_comments}</h3>
                    <p className="t-p1 t-400 t-dark3">
                        {reviewsList?.data.count} {lang.comments_service}
                    </p>
                </span>
                {!reviewsList ? <div className={`w-100 pv-6 center-content ${styles['loading']}`}>
                        <Spin />
                    </div> : <div className={`${styles['card-list']}`}>
                        {reviewsList.data.data.map((item, index) => <ReviewCardComp key={index} data={item} />)}
                    </div>}
            </div>
            <div className={`${styles['pagination-review-layout']} ${reviewsList?.data.count && reviewsList?.data.count > 4 ? 'd-flex' : 'd-none'} center-content`}>
                <div className={`${styles['pagination-review']} d-flex center-content`}>
                    <Pagination size="small" current={reviewsList ? reviewsList.page : 1} pageSize={4} total={reviewsList?.data.count} showSizeChanger={false} hideOnSinglePage onChange={getComments} data-sentry-element="Pagination" data-sentry-source-file="serviceDetail.index.tsx" />
                </div>
            </div>
        </div>;
}
export default ServiceDetailComp;